import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthGuard } from '../_guards/auth.guard';
import { RequestEmailComponent } from './request-email/request-email.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { CreateProfileComponent } from './create-profile/create-profile.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  /* { path: 'register', component: RegisterComponent }, */
  { path: 'reset-password', component: ChangePasswordComponent },
  { path: 'request-email', component: RequestEmailComponent },
  { path: 'subscription-plan', component: SubscriptionComponent, data: { title: 'subscription-plan' } },
  { path: 'create-profile', component: CreateProfileComponent, data: { title: 'create-profile' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
